import React from "react";
import About from "../components/site/About";
import PageShell from "./PageShell";

export default function AboutPage() {
  return (
    <PageShell testid="about-page">
      <About />
    </PageShell>
  );
}
